<template>
  <div class="prize-box">
    <div v-if="prizeList.length == 1 && prizeList[0].couponName !== '' && prizeList[0].couponName !== undefined && prizeList[0].couponName !== null" class="onePrize">
      <img class="pic" :src="prizeList[0].adInfo?.pictureUrl || prizeList[0].adInfo?.conditionMap.positionResourceFile1[0].value">
      <div class="text">{{ prizeList[0].couponName }}</div>
      <div class="exchange">
        <div class="exc-btn" :class="{'disable':!exchangeStatus}" @click="exchange(prizeList[0])">
          <span v-if="exchangeStatus" class="use">使用</span>
          <span class="num">{{prizeList[0].requiredPoints}}</span>
          <img src="../../../assets/pointsActivity/xingxing@2x.png">
          <span>兑换</span>
        </div>
      </div>
    </div>
    <div class="prize-item" v-for="(item, index) in prizeList" :key="index" v-show="prizeList.length > 1 &&item.couponName !== '' && item.couponName !== undefined && item.couponName !== null" >
      <div>
        <van-image
          width="100%"
          fit="cover"
          style="margin: auto;"
          :src="item.adInfo?.pictureUrl || item.adInfo?.conditionMap.positionResourceFile1[0].value"
      />
        <div class="prize-body">
          <div class="texts">{{ item.couponName }}</div>
          <div class="exchange" v-if="!isLogin">
            <div class="exc-btn" :class="{'disable': isLogin}" @click="toPage('packages/common/login/index')">
              <span v-if="exchangeStatus" class="use">使用</span>
              <span class="num">{{item.requiredPoints}}</span>
              <img src="../../../assets/pointsActivity/xingxing@2x.png" class="exc-btn-img">
              <span class="exc-btn-text">兑换</span>
            </div>
          </div>
          <div class="exchange" v-else>
            <div class="exc-btn" :class="{'disable':!exchangeStatus}" @click="exchange(item)">
              <span v-if="exchangeStatus" class="use">使用</span>
              <span class="num">{{item.requiredPoints}}</span>
              <img src="../../../assets/pointsActivity/xingxing@2x.png" class="exc-btn-img">
              <span class="exc-btn-text">兑换</span>
            </div>
          </div>
        </div>
      </div>
  </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
export default {
  name: "prize",
  props:{
    exchangeStatus: {
      type: Boolean,
      default: false,
    },
    prizeList: {
      type:Array,
      default:[]
    },
    isLogin: {
      type: Boolean,
      default: false,
    },
    linkTerminal: {
      type: Number,
      default: null
    }
  },
  watch:{
  },
  mounted () {
    this.prizeList.forEach((item, index) => {
      if (item.requiredPoints == '' || item.requiredPoints == undefined || item.requiredPoints == null || item.requiredPoints == 0) {
        this.prizeList = this.prizeList.splice(index, 1);
      }
    })
  },
  methods:{
    exchange(item){
      this.$emit('getExchange',item)
    },
     toPage(url) {
       if (this.linkTerminal == 3 || this.linkTerminal == '3') {
          try {
            const data = ''
            NavigationLogin.postMessage(data)
          } catch (e) {
            console.warn('NavigationLogin is error')
            console.warn(e)
          }
       } else {
         wx.miniProgram.navigateTo({
          url: `/${url}`,
        });
       }
      
    },
  },
}
</script>

<style lang="scss" scoped>
.prize-box{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  .onePrize{
    width: 100%;
    //padding: 24px;
    padding-bottom: 24px;
    background: #F5F6F7;
    border-radius: 16px;
    margin-bottom: 16px;

    .pic{
      display: block;
      width: auto;
      height: 280px;
      margin: auto;
      border-radius: 16px 16px 0 0;
    }

    .text{
      text-align: center;
      padding: 0 24px;
      color: #3A3B3C;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      margin-top: 24px;
      line-height: 40px;
      font-size: 28px;
    }

    .exchange{
      padding: 0 24px;
      margin-top: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      .exc-btn{
        width: 352px;
        height: 36px;
        padding: 22px 0;
        background: #FBE7E5;
        border-radius: 8px;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        font-size: 24px;
        color: #3A3B3C;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        .use{
          // margin-right: 10px;
          // padding-top: 4px;
          height: 32px;
          line-height: 36px;
          margin:0 6px;
          vertical-align: middle;
        }
        .num{
          font-size: 48px;
          font-family: "D-DIN-PRO-500-Medium";
          font-weight: 500;
          line-height: 60px;
          color: #A52337;
          align-self:  center;
        }

        img{
          width: 32px;
          height: 32px;
          margin:0 6px;
          vertical-align: middle;
        }
        &.disable {
          opacity: .6;
        }
      }


      .activebtn{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 108px;
        height: 48px;
        //line-height: 48px;
        text-align: center;
        border-radius: 8px;
        font-size: 22px;
        background: #FBE7E5;
        color: #A52337;
        border: 1px solid #A52337;
      }
    }
  }
  .prize-item{
    width: calc(50% - 8px);
    padding: 0;
    background: #F5F6F7;
    border-radius: 16px;
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .prize-body {
      padding: 24px 24px 32px 24px;
      .pic{
      display: block;
      width: 100%;
      max-width: 100%;
      height: auto;
      margin: auto;
    }

    .text{
      color: #3A3B3C;
      margin-top: 36px;
      line-height: 40px;
      height: 80px;
      font-size: 24px;
      display: -webkit-box;
      text-overflow: ellipsis;
      overflow: hidden;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;//当属性值为3，表示超出3行隐藏
    }
    .texts{
      text-align: center;
      color: #3A3B3C;
      // margin-top: 12px;
      line-height: 43px;
      height: 80px;
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      display: -webkit-box;
      text-overflow: ellipsis;
      overflow: hidden;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;//当属性值为3，表示超出3行隐藏
    }
    .exchange{
      margin-top: 24px;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;

      .exc-btn{
        width: 100%;
        height: 72px;
        line-height: 72px;
        background: #FBE7E5;
        border-radius: 8px;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        font-size: 24px;
        color: #3A3B3C;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        .use{
          // margin-right: 10px;
          // padding-top: 4px;
          height: 32px;
          line-height: 36px;
          margin:10px 6px 16px 6px;
          vertical-align: middle;
        }
        .num{
          font-size: 48px;
          font-family: "D-DIN-PRO-500-Medium";
          font-weight: 500;
          line-height: 60px;
          color: #A52337;
          align-self:  center;
        }
        .exc-btn-img{
          width: 32px;
          height: 32px;
          line-height: 12px;
          margin:0px 6px 16px 6px;
          vertical-align: middle;
        }
        .exc-btn-text {
           font-size: 24px;
           color: #3A3B3C;
           font-family: PingFangSC-Medium, PingFang SC;
           font-weight: 500;
           line-height: 32px;
           margin:0px 0 14px 0;

        }
        &.disable {
          opacity: .6;
        }
      }

      .btn{
        width: 108px;
        height: 48px;
        line-height: 48px;
        text-align: center;
        background: #F8EEEE;
        border-radius: 8px;
        color: #E49594;
        font-size: 22px;
      }
    }
    }
  }
}
::v-deep .van-image__img {
    border-radius: 16px 16px 0px 0px !important;
}
</style>

